export const LS = {
    PRODUCT_VIEW_LIMIT: 'productViewLimit',
    LOCALE: 'locale',
    CART: 'cart',
};
